import { render, staticRenderFns } from "./WebsiteType.vue?vue&type=template&id=7b6e1dd9&scoped=true&"
import script from "./WebsiteType.vue?vue&type=script&lang=js&"
export * from "./WebsiteType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e1dd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6e1dd9')) {
      api.createRecord('7b6e1dd9', component.options)
    } else {
      api.reload('7b6e1dd9', component.options)
    }
    module.hot.accept("./WebsiteType.vue?vue&type=template&id=7b6e1dd9&scoped=true&", function () {
      api.rerender('7b6e1dd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/WebsiteType.vue"
export default component.exports